import React from "react";

export const profilePromotionColumns = ({handleEdit, handleDelete, PAGE_SIZE, isOpen}) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Profile Id",
    render: (row) => <span>{row.member_id?.profile_id || "-"}</span>,
  },
  {
    label: "Listing",
    render: (row) => (
        <span>{row.listing || "-"}</span>
    )
  },
  {
    label: "From Date",
    render: (row) => (
      <div>
       {row?.fromDate
                ? new Date(row.fromDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
      </div>
    ),
  },
  {
    label: "To Date",
    render: (row) => (
      <div>
       {row?.toDate
                ? new Date(row.toDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
      </div>
    ),
  },
  {
    label: "Position",
    render: (row) => (
      <div>
       {row?.position || "-"}
      </div>
    ),
  },
  {
    label: "Performance",
    render: (row) => (
      <div>
        <a href="#" className="sitebtn text-white text-center px-1 py-0 mb-2" onClick={e => { e.preventDefault(); isOpen(row?.member_id?.profile_id); }} title="View History" style={{fontSize: "12px", textDecoration: "none", display: "inline-block"}}>
          <i className="fa fa-eye" aria-hidden="true"></i> View
        </a>
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <a href="#" onClick={e => { e.preventDefault(); handleEdit(row); }}>
            <i className="fa fa-edit" />
          </a>
        </li>
        <li>
          <a href="#" onClick={e => { e.preventDefault(); handleDelete(row._id); }}>
            <i className="fa fa-trash" />
          </a>
        </li>
      </ul>
    ),
  },
];
